import { FormModal } from '~/shared/forms/FormModal';
import { editDischargePlanOptions, getDischargePlansOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { DischargePlanFormBody, initialValues, validationSchema } from './DischargePlanFormBody';

export function DischargePlanFormModal({ certificationPeriodId, closeModal }: { certificationPeriodId: string; closeModal: () => void }) {
	const { data: dischargePlans } = useSuspenseQuery(getDischargePlansOptions(certificationPeriodId));
	const dischargePlan = dischargePlans.pending ?? dischargePlans.current;
	return (
		<FormModal
			title="Edit Discharge Plan"
			initialValues={{
				...initialValues,
				...dischargePlan
			}}
			saveMutation={{
				...editDischargePlanOptions,
				invalidateQueryKeys: [getDischargePlansOptions(certificationPeriodId).queryKey]
			}}
			validationSchema={validationSchema}
			onSuccess={closeModal}
			closeModal={closeModal}
		>
			<DischargePlanFormBody />
		</FormModal>
	);
}
